var _defs, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEbusinessShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ebusiness-shop_svg__a",
    d: "M10.2 4.9c-.1-.3.1-.6.5-.7.3-.1.6.1.7.5l.5 2.7c.1.3-.1.6-.5.7-.3.1-.6-.1-.7-.5l-.5-2.7zm-2.3 0l-.5 2.7c-.1.3-.4.5-.7.5-.3-.1-.5-.4-.4-.7l.5-2.7c.1-.3.4-.5.7-.4.3 0 .5.3.4.6zM6.8 8.7c.2 0 .3.1.4.2.4.6 1.1.9 1.8.9s1.4-.3 1.8-.9c.1-.1.3-.2.4-.2h3.2l-1.3-5.1H4.9L3.6 8.7h3.2zM4.6 9.8v4.5c0 .3.3.6.6.6H13c.3 0 .6-.3.6-.6V9.8h-2c-.6.7-1.5 1.1-2.5 1.1s-1.9-.4-2.5-1.1h-2zm10.1 0v4.5c0 .9-.8 1.7-1.7 1.7H5.1c-.9 0-1.7-.8-1.7-1.7V9.8h-.5c-.4 0-.6-.3-.5-.7L4 2.9c0-.2.3-.4.5-.4h9.1c.3 0 .5.2.5.4l1.6 6.2c.1.4-.2.7-.5.7h-.5z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ebusiness-shop_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ebusiness-shop_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ebusiness-shop_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ebusiness-shop_svg__c",
    d: "M-561.9-1555.8h1424v1994h-1424z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ebusiness-shop_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ebusiness-shop_svg__c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#ebusiness-shop_svg__d)",
    d: "M-2.7-2.5h23.5V21H-2.7z"
  }))));
}

export default SvgEbusinessShop;